import React from 'react'

function RadioButtonDash({ options = [], onChange, ...props }) {
  const checkchange = (check) => check === props.checked

  let width = '1000px' // Seems unused for responsiveness; you can replace with props if needed

  return (
    <div
      className={`w-full items-center ${
        width === 'sm' || width === 'xs' ? '' : 'flex'
      }`}
    >
      <span
        className={`flex items-center justify-between ${
          width === 'sm' || width === 'xs' ? 'w-full' : 'w-5/12 p-0 mr-1'
        }`}
      >
        <span
          className={`${
            width === 'sm' || width === 'xs'
              ? `p-0 flex flex-row justify-start mb-2 ${
                  props.error ? 'text-red-500' : ''
                }`
              : `mr-1 flex flex-row justify-start ${
                  props.error ? 'text-red-500' : ''
                }`
          }`}
        >
          {props.label}
          {/* {props.required && <span className="text-red-500">*</span>} */}
        </span>
        {width === 'xs' || width === 'sm' ? null : (
          <span className="pr-1">:</span>
        )}
      </span>

      <div className="flex w-full ml-1 md:w-7/12">
        {options.map((opt, index) => (
          <div className="pr-3 flex items-center" key={index}>
            <input
              onChange={onChange}
              name={props.name ?? 'name'}
              className={`mr-2 ${props.required ? 'required' : ''}`}
              type="radio"
              value={opt.value}
              checked={checkchange(opt.value)}
              defaultChecked={checkchange(opt.value)}
            />
            <label className="p-0">{opt.label}</label>
          </div>
        ))}
      </div>
    </div>
  )
}

export default RadioButtonDash
